import { DashboardComponent } from "./dashboard.component";
import { PersonActivitiesGraphComponent } from "./person-activities-graph.component";
import { PersonsOnBoardGraphComponent } from "./person-onboard-graph.component";
import { PersonsCompetencesStatusGraphComponent } from "./person-competences-status-graph-component";

import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { dashboardState } from "./dashboard.states";
import { AllMaterialModule } from "../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

var STATES = [dashboardState];

@NgModule({
    imports: [
        AllMaterialModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: STATES })
    ],
    declarations: [DashboardComponent, PersonActivitiesGraphComponent, PersonsOnBoardGraphComponent, PersonsCompetencesStatusGraphComponent]
})
export class DashboardModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/dashboard/dashboard.module.ts